import { useParams } from "react-router-dom";

import articles from "../data/articles.json";
import bands from "../data/bands.json";

import NewsDetails from "../components/NewsDetails";
import RecentNews from "../components/RecentNews";
import UpcomingReleases from "../components/UpcomingReleases";

import "../styles/newsdetailsscreen.css";

const NewsDetailsScreen = () => {
  const { slug } = useParams();

  const cleanSlug = decodeURIComponent(slug || "").trim();

  const article = articles.find(
    (article) => article.slug === cleanSlug
  );

  if (!article) {
    return (
      <section className="news-details-page py-6">
        <div className="container">
          <h1>News Not Found</h1>

          <p>We couldn't find that news item.</p>

          <p>
            <strong>Slug:</strong> {cleanSlug}
          </p>
        </div>
      </section>
    );
  }

  let band = null;

  if (article.band_id) {
    band = bands.find(
      (band) =>
        String(band.id) === String(article.band_id)
    );
  }

  if (!band && article.band_name) {
    band = bands.find(
      (band) =>
        band.name.toLowerCase() ===
        article.band_name.toLowerCase()
    );
  }

  const news = {
    ...article,
    band: band || null,
  };

  return (
    <section className="news-details-page py-6">
      <div className="container">
        <div className="row g-5">
          <div className="col-12 col-xl-8">
            <div className="news-details-main">
              <NewsDetails news={news} />
            </div>
          </div>

          <div className="col-12 col-xl-4">
            <aside className="news-details-sidebar">
              <RecentNews limit={4} />

              <div className="mt-5">
                <UpcomingReleases limit={5} />
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsDetailsScreen;